module.exports = __webpack_public_path__ + "img/person-inactive.4d559f4d.svg";